import {
  ChannelConfigAutomod,
  ChannelConfigAutomodBehavior,
  CommandResponse,
  CreateChannelOptions,
  DefaultGenerics,
  PermissionObject
} from 'stream-chat';

interface ChatChannelTypeInterface
  extends Omit<
    CreateChannelOptions<DefaultGenerics>,
    'client_id' | 'connection_id' | 'commands'
  > {
  commands: CommandResponse<DefaultGenerics>[];
  created_at: string;
  updated_at: string;
  grants?: Record<string, string[]>;
}

export class ChatChannelTypeDto implements ChatChannelTypeInterface {
  commands: CommandResponse<DefaultGenerics>[];
  created_at: string;
  updated_at: string;
  grants?: Record<string, string[]>;
  automod?: ChannelConfigAutomod;
  automod_behavior?: ChannelConfigAutomodBehavior;
  automod_thresholds?: { explicit?: { block?: number; flag?: number; }; spam?: { block?: number; flag?: number; }; toxic?: { block?: number; flag?: number; }; };
  blocklist?: string;
  blocklist_behavior?: ChannelConfigAutomodBehavior;
  connect_events?: boolean;
  custom_events?: boolean;
  mark_messages_pending?: boolean;
  max_message_length?: number;
  message_retention?: string;
  mutes?: boolean;
  name?: string;
  permissions?: PermissionObject[];
  polls?: boolean;
  push_notifications?: boolean;
  quotes?: boolean;
  reactions?: boolean;
  read_events?: boolean;
  reminders?: boolean;
  replies?: boolean;
  search?: boolean;
  typing_events?: boolean;
  uploads?: boolean;
  url_enrichment?: boolean;
}
